<div [hidden]="!_messagingService.NC_Visiblity">
    <div class="notificationCenter shadow-lg d-flex">
        <div class="card flex-fill notificationContainer">
            <div class="card-header">
                <h4 class="card-title float-left" translate>LBL.NOTIFICATIONS</h4>
                <button aria-label="Close" (click)="onClose()" class="close float-right" type="button"><span aria-hidden="true">×</span></button>

            </div>
            <div class="card-body p-0">
                <div class="actionbar d-flex">
                    <div class="mr-2"><a href="javascript:{}" routerLink="Inbox/Inbox" translate>NAV.NAV_INBOX</a></div>
                    <div class="mr-2">|</div>
                    <div class=""><a href="javascript:{}" (click)="onDismissAll()" translate>BTN.BTN_DISMISS_ALL</a></div>
                </div>
                <div *ngIf="Model && Model.length > 0">
                    <div class="messagebox d-flex" *ngFor="let row of Model">
                        <div class="content-area d-flex" (click)="onMessageClick(row)">
                            <div class="mr-3">
                                <img src="/Images/EventTypes/n_{{row.EventId}}.png" class="icon" title="{{row.EventDescription}}"/>
                            </div>
                            <div>
                                <div class="" [ngClass]="row.IsRead == false ? 'font-weight-bold' : ''">{{(row.Message.length > 75) ? (row.Message | slice:0:75) + " ..." : (row.Message)}}</div>
                                <div class="text-muted small">{{row.CreatedAt | amDateFormat: DateFormat}} - {{row.EventDescription}} <span *ngIf="row.OwnerId">- <span *ngIf="row.OwnerId > 0">{{row.OwnerName}}</span><span *ngIf="row.OwnerId == 0">System</span></span></div>
                            </div>
                        </div>
                        <div class="btn_close" (click)="onMessageDismiss(row)"><i class="fas fa-window-close"></i></div>
                    </div>
                </div>
                <div *ngIf="Model == null || Model.length <= 0" class="px-2">
                    <div class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>
                </div>
            </div>
        </div>
    </div>
    <MessageDetail #messageDetail></MessageDetail>
</div>


